import React, { Component } from "react";
import { Row, Col } from "reactstrap";

import { Route, Switch } from "react-router-dom";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import CardTypesList from "./List";
import CardTypeForm from "./Form";
import CardType from "./View";
import NotFound from "../NotFound";

import { PageHeader } from "../Shared";

import { cardTypeActions } from "./actions/cardstypes.actions";

export class ManageCardTypes extends Component {
  componentDidMount() {
    this.getCardTypes();
  }

  getCardTypes = () => {
    this.props.getCardTypes();
  };

  render() {
    const { fetching, fetched, response, error, match } = this.props;

    return (
      <div className="CardTypes">
        <Row>
          <Col>
            <PageHeader pageId="cardtypes" pageTitle="Manage Card Types" />
          </Col>
        </Row>

        <div className="content-wrapper">
          <Switch>
            <Route
              exact
              path={match.url}
              render={() => (
                <CardTypesList
                  match={match}
                  data={response}
                  loadData={this.getCardTypes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route
              path={`${match.url}/list`}
              render={() => (
                <CardTypesList
                  match={match}
                  data={response}
                  loadData={this.getCardTypes}
                  fetching={fetching}
                  fetched={fetched}
                  error={error}
                />
              )}
            />
            <Route path={`${match.url}/add`} component={CardTypeForm} />
            <Route path={`${match.url}/view/:id`} component={CardType} />
            <Route path={`${match.url}/edit/:id`} component={CardTypeForm} />
            <Route component={NotFound} />
          </Switch>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { fetching, fetched, response, error } = state.cardTypes;
  return {
    fetching,
    fetched,
    response,
    error
  };
};

const mapDispatchToProps = dispatch => {
  return {
    getCardTypes: bindActionCreators(
      cardTypeActions.getAllCardTypes,
      dispatch
    )
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCardTypes);
